import React, { forwardRef } from 'react';
import { Box } from '@mui/material';
import { ImageContainerProps } from '../../types';
import { getTransformStyle } from '../../utils/imageTransform';

const ImageContainer = forwardRef<HTMLDivElement, ImageContainerProps>(({
  imageUrl,
  transform,
  isDragging,
  onDoubleClick,
  onMouseDown,
}, ref) => {
  return (
    <Box
      ref={ref}
      sx={{
        flex: 1,
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
      }}
    >

      {/* Image */}

      <Box
        component="img"
        src={imageUrl}
        alt="Receipt"
        sx={{
          // Remove width constraints - let transform scale handle sizing
          display: 'block',
          transform: getTransformStyle(transform),
          transformOrigin: 'center top',
          willChange: 'transform',
          transition: isDragging ? 'none' : 'transform 0.2s cubic-bezier(0.4,0,0.2,1)',
          cursor: isDragging ? 'grabbing' : 'grab',
          userSelect: 'none',
        }}
        onDoubleClick={onDoubleClick}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={onMouseDown}
      />


      {/* Grid Overlay */}
      {/* <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          pointerEvents: 'none',
          backgroundImage: `
            linear-gradient(to bottom, #2C6CA0 2px, transparent 2px)
          `,
          backgroundSize: '100% 42px',
          backgroundPosition: '0 0',
          opacity: 1,
          zIndex: 1,
        }}
        onClick={(e) => e.stopPropagation()}
      /> */}

      {/* Info */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 8,
          left: 8,
          bgcolor: 'rgba(0, 0, 0, 0.7)',
          color: 'white',
          px: 1,
          py: 0.5,
          borderRadius: 1,
          fontSize: '0.75rem',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {Math.round(transform.scale * 100)}% | {transform.rotation}° | Drag to pan | Double-click to toggle zoom
      </Box>
    </Box>
  );
});

export default ImageContainer; 